import React, { useRef } from "react";
import UsumLogo from "../../assets/images/logo-usum-software.png";
import { useIntersection } from "../../hooks";
interface iWorkExperience {
  imgLogo: string;
  companyName: string;
  linkCompany: string;
  nameJob?: string;
  timeJob?: string;
  desJob?: string[];
  rev?: boolean;
  colorCode: `#${string}`;
}
const Item: React.FC<iWorkExperience> = (props) => {
  const {
    imgLogo,
    companyName,
    linkCompany,
    nameJob,
    timeJob,
    desJob,
    rev,
    colorCode,
  } = props;
  const divRef = useRef(null);
  const sectionRef = useIntersection(divRef, "0px");
  return (
    <div
      ref={divRef}
      className={
        " " + rev && rev
          ? " flex flex-row-reverse justify-center items-center phone:flex-col phone:items-start phone "
          : " flex justify-center items-center phone:flex-col phone:items-start "
      }
    >
      <img
        className={
          "w-1/5 tablet:w-1/4 phone:w-1/2 left-0 duration-1000  " +
          (sectionRef
            ? " opacity-100 blur-0 translate-x-0  "
            : " opacity-0 blur-sm ") +
          (!sectionRef && " translate-x-full ")
        }
        src={imgLogo || UsumLogo}
        alt="UsumLogo"
      />
      <div
        className={
          "flex-1 pl-4 phone:pl-0 phone:pt-4  duration-1000 " +
          (sectionRef
            ? " opacity-100 blur-0 translate-x-0   "
            : " opacity-0 blur-sm ") +
          (!sectionRef
            ? " -translate-x-full "
            : !sectionRef && " -translate-x-full ")
        }
      >
        <div className="">
          <h1 className="text-2xl font-bold">
            {nameJob ? nameJob : "ReactJS Developer"}
          </h1>
          <p className="text-xs ">{timeJob ? timeJob : "06/2022 - 11/2022"}</p>
        </div>
        <div className="pl-1 mt-1 text-s mb-3">
          {desJob ? (
            desJob.map((i) => <p key={i}>+ {i}</p>)
          ) : (
            <>
              <p>
                + Use React Library, TailwindCss, Figma, Restful api - Axios...
              </p>
              <p>+ Training ReactNative and Native Base Library.</p>
              <p>
                + Join a{" "}
                <a
                  className=" text-[#FFC107]  hover:text-[#FFC107]  hover:cursor-pointer hover:underline"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.gogobeivn.com/"
                >
                  Gogobei
                </a>{" "}
                and{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.dakoli.com/"
                  className="text-green-600"
                >
                  Dakoli
                </a>{" "}
                project.
              </p>
            </>
          )}
        </div>
        <a
          className={`py-1 px-2 dark:bg-bgLight bg-bgDark text-white rounded-md dark:text-greyDark hover:text-[var(--colorCode)] dark:hover:text-[var(--colorCode)] text-lg`}
          href={linkCompany || "https://www.usumsoftware.com/"}
          target="_blank"
          rel="noreferrer"
          style={{ "--colorCode": colorCode } as React.CSSProperties}
        >
          About {companyName}
        </a>
      </div>
    </div>
  );
};

export default Item;
